export const leagueKeys = {
	recommendedAll: () => ['RECOMMENDED_LEAGUES'] as const
};
